import React from "react";
import * as s from "./CreateClient.styles";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../components/shared/inputs/FormikControl";

// reducer
import * as actions from "../../../store/actions/index";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// images
import logo from "../../../assets/images/logo.png";

const CreateClient = () => {
  const dispatch = useDispatch();

  const history = useHistory();

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    conpassword: "",
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const validationSchema = Yup.object({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email format").required("Required"),
    phoneNumber: Yup.string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Required")
      .min(0),
    password: Yup.string().required("Required"),
    conpassword: Yup.string()
      .oneOf([Yup.ref("password"), ""], "Passwords must match")
      .required("Required"),
  });

  const togglePassword = () => {
    const togglePassword = document.querySelector("#togglePassword");
    const password = document.querySelector("#password");

    // toggle the type attribute
    const type =
      password.getAttribute("type") === "password" ? "text" : "password";
    password.setAttribute("type", type);
    // toggle the eye slash icon
    togglePassword.classList.toggle("fa-eye-slash");
  };
  const toggleConPassword = () => {
    const toggleConPassword = document.querySelector("#toggleConPassword");
    const password = document.querySelector("#conpassword");

    // toggle the type attribute
    const type =
      password.getAttribute("type") === "password" ? "text" : "password";
    password.setAttribute("type", type);
    // toggle the eye slash icon
    toggleConPassword.classList.toggle("fa-eye-slash");
  };

  const onSubmit = (values) => {
    let { conpassword, ...data } = values;
    // console.log("Form data", data);

    dispatch(actions.createClient(data, () => history.goBack()));
  };
  return (
    <s.ScreenContainer>
      <s.Container>
        <s.LogoContainer>
          <s.LogoImage src={logo} />
        </s.LogoContainer>
        <s.FormContainer>
          <s.H1>Create new client</s.H1>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => {
              return (
                <Form>
                  <s.InputContainer>
                    <FormikControl
                      control="input"
                      // control='chakraInput'
                      type="text"
                      name="firstName"
                      placeholder="FIRST NAME"
                    />
                  </s.InputContainer>
                  <s.InputContainer>
                    <FormikControl
                      control="input"
                      // control='chakraInput'
                      type="text"
                      name="lastName"
                      placeholder="LAST NAME"
                    />
                  </s.InputContainer>
                  <s.InputContainer>
                    <FormikControl
                      control="input"
                      // control='chakraInput'
                      type="email"
                      name="email"
                      placeholder="EMAIL"
                    />
                  </s.InputContainer>
                  <s.InputContainer>
                    <FormikControl
                      control="input"
                      // control='chakraInput'
                      type="text"
                      name="phoneNumber"
                      placeholder="PHONE NUMBER"
                    />
                  </s.InputContainer>
                  <s.InputContainer>
                    <FormikControl
                      control="input"
                      type="password"
                      name="password"
                      id="password"
                      placeholder="PASSWORD"
                    />
                    <s.Eye
                      className="far fa-eye"
                      onClick={togglePassword}
                      id="togglePassword"
                    ></s.Eye>
                  </s.InputContainer>
                  <s.InputContainer>
                    <FormikControl
                      control="input"
                      type="password"
                      name="conpassword"
                      id="conpassword"
                      placeholder="CONFIRM PASSWORD"
                    />
                    <s.Eye
                      className="far fa-eye"
                      onClick={toggleConPassword}
                      id="toggleConPassword"
                    ></s.Eye>
                  </s.InputContainer>
                  <s.Div>
                    <s.CreateBtn
                      type="submit"
                      disabled={!formik.isValid}
                      onClick={onSubmit}
                    >
                      Create
                    </s.CreateBtn>
                  </s.Div>
                </Form>
              );
            }}
          </Formik>
        </s.FormContainer>
      </s.Container>
    </s.ScreenContainer>
  );
};

export default CreateClient;
